import { FormControl, FormHelperText, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';
import React from 'react';

const SelectSimple = ({
  id,
  name,
  label,
  onChange,
  options,
  value,
  error,
  disabled = false,
  readOnly = false,
  defaultValue = '',
}) => {
  const menuItens =
    options &&
    options.map((item, index) => {
      return (
        <MenuItem key={index} value={item.id}>
          {item.title}
        </MenuItem>
      );
    });

  const padrao = (value || defaultValue) && options.find((item) => item.id === value || item.id === defaultValue).title;
  if (readOnly) {
    return <TextField disabled id={id} label={label} defaultValue={padrao} />;
  }

  return (
    <FormControl fullWidth variant="outlined" disabled={disabled}>
      <InputLabel shrink id={id}>
        {label}
      </InputLabel>
      <Select
        labelId={id}
        id={id}
        name={name}
        value={value || defaultValue}
        onChange={(event) => {
          const newEvent = {
            target: {
              id,
              name: id,
              value: event.target.value,
            },
          };
          onChange(newEvent);
        }}
        label={label}
      >
        {menuItens}
      </Select>

      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};
SelectSimple.propTypes = {};

SelectSimple.defaultProps = {};

export default SelectSimple;
